import { render, staticRenderFns } from "./DuctDespatch.vue?vue&type=template&id=1b7bdd3c&scoped=true&"
import script from "./DuctDespatch.vue?vue&type=script&lang=js&"
export * from "./DuctDespatch.vue?vue&type=script&lang=js&"
import style0 from "./DuctDespatch.vue?vue&type=style&index=0&id=1b7bdd3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bdd3c",
  null
  
)

export default component.exports